import Thunk from './';
import { Data, List } from 'src/interfaces/general';
import homeworkReplyCommentActions from 'src/store/model/homework_reply_comment';
import homeworkCommentActions from 'src/store/model/homework_comment';

const homework_comments = new Thunk('homework_comments');

export type HomeworkCommentPayload = Partial<Model.HomeworkComment>;

export const fetchHomeworkCommentReply = homework_comments.fetch<
  List<Model.HomeworkComment>,
  SearchParams.HomeworkComment
>({
  onSuccess({ data, dispatch }) {
    dispatch(homeworkReplyCommentActions.updateEntities(data.data));
  },
});

export const createHomeworkCommentReply = homework_comments.create<
  Data<Model.HomeworkComment>,
  HomeworkCommentPayload
>({
  onSuccess({ data, dispatch }) {
    dispatch(homeworkReplyCommentActions.updateEntity(data.data));
    dispatch(homeworkCommentActions.increaseNumberOfComments(data.data));
  },
});

export const updateHomeworkCommentReply = homework_comments.update<
  Data<Model.HomeworkComment>,
  HomeworkCommentPayload
>({
  onSuccess({ data, dispatch }) {
    dispatch(homeworkReplyCommentActions.updateEntity(data.data));
  },
});

export const deleteHomeworkCommentReply = homework_comments.remove({
  onSuccess({ args, dispatch }) {
    dispatch(homeworkReplyCommentActions.removeEntity(args));
    dispatch(homeworkCommentActions.decreaseNumberOfComments(args));
  },
});
